import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';

/**
 * Assignment Groups Fetch Policy (TV1-1878)
 *
 * Responsibilities:
 * - Fetch the account's assignment groups from AssignmentGroupsReadmodel on init
 * - Dispatch account/groups/data/setAll
 * - Handle loading state
 */
export const createGroupsFetchPolicy = (
  backend: ClientLibraryType,
  accountId: string
): Policy<AccountState, AccountCommand> => ({
  name: 'groups-fetch',

  init: ({ dispatch }) => {
    ( async () => {
      dispatch(
        { type: 'account/groups/loading/setFetching', payload: { isLoading: true }},
        { source: 'api' }
      );
      try {
        const response = await backend.queries.AssignmentGroupsReadmodel({
          filter: [{ field: 'accountId', op: 'eq', value: accountId }]
        } as any );
        const rows: any[] = Array.isArray( response ) ? response : ( response as any )?.items ?? [];
        const groups = rows.map(( g ) => ({
          id: g.id,
          accountId: g.accountId,
          name: g.name,
          memberUserIds: Array.isArray( g.memberUserIds ) ? g.memberUserIds : []
        }));
        dispatch(
          { type: 'account/groups/data/setAll', payload: { groups }},
          { source: 'api' }
        );
      } catch ( error ) {
        console.error( '[account] Assignment groups fetch error:', error );
      } finally {
        dispatch(
          { type: 'account/groups/loading/setFetching', payload: { isLoading: false }},
          { source: 'api' }
        );
      }
    })();

    return undefined;
  }
});
